import Cookies from "js-cookie";
import { useCallback, useState } from "react";
import { SwitchParams } from "../OverviewPopper/type";
import useAction from "./useAction";
import useSubAccountListen from "./useSubAccountListen";
import { copyTradingHeader } from "@/nav-localized/config";

const getSavedFingerprintID = () => {
  try {
    let requestId: string = Cookies.get("requestId") || "";
    if (!requestId && typeof window !== "undefined" && window.localStorage) {
      requestId = window.localStorage.getItem("requestId") || "";
    }
    return requestId;
  } catch (error) {
    console.log("getSavedFingerprintID error: ", error);
  }
  return "";
};

const useSwitchAccount = (base?: string) => {
  const { getToken, getCopyTradeUserInfo } = useAction(base);

  const [isFatching, setIsFatching] = useState(false);

  const { triggerSubAccountChange } = useSubAccountListen();

  const switchTo = useCallback(
    async (params: SwitchParams) => {
      try {
        sessionStorage.removeItem("global-role");
        if (isFatching) return;
        setIsFatching(true);
        Cookies.set("isSwitching", "1", { expires: 365 });
        const isSwitchToSub = params.type === "MAIN_TO_SUB" || params.type === "SUB_TO_SUB";
        const getTokenRes = getToken<{
          code: number;
          data: { token: string };
          msg: string;
        }>(params, {
          headers: {
            "fp-request-id": getSavedFingerprintID()
          }
        });
        const response = await getTokenRes;
        if (response.code === 200 && response.data.token) {
          Cookies.set("token", response.data.token, { expires: 365 });
          if (isSwitchToSub) {
            Cookies.set("Global-AccountType", "NORMAL_SUB_ACCOUNT", { expires: 365 });
          }
          if (params.type === "SUB_TO_MAIN") {
            Cookies.set("Global-AccountType", "MAIN", { expires: 365 });
          }
          if (isSwitchToSub) {
            const userInfo = await getCopyTradeUserInfo<{ code: number; data: { role: number } }>({
              headers: {
                [copyTradingHeader]: "1"
              }
            });
            if (userInfo.code === 200) {
              Cookies.set("role", userInfo.data?.role.toString(), { expires: 365 });
            } else {
              Cookies.remove("role");
            }
          } else {
            Cookies.remove("role");
          }
          triggerSubAccountChange(params);
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          window && window.location.reload();
        } else {
          setIsFatching(false);
          Cookies.remove("isSwitching");
          console.error("switchTo error", response.msg);
        }
      } catch (error) {
        setIsFatching(false);
        console.error(error);
      }
    },
    [triggerSubAccountChange, getToken, isFatching]
  );

  return {
    switchTo
  };
};

export default useSwitchAccount;
